export const stringToBoolean = (string: string ) => (string === 'false' ? false : !!string);
